// extracted by mini-css-extract-plugin
export var button = "button-module--button--3-FfO";
export var primaryButton = "button-module--primary-button--2ol6i";
export var text = "button-module--text--2Orwh";
export var secondaryButton = "button-module--secondary-button--1zO8H";